import { useEffect } from 'react';

import { GlobalStyle } from 'environment/theme/global';
import { getLanguage } from 'store/ui/i18n';
import { useLanguage } from 'features/hooks/useLanguage';

import { useDispatch } from 'hooks/utils';

interface Props {
	children: React.ReactNode;
}

export function Init({ children }: Props) {
	const dispatch = useDispatch();
	const language = useLanguage();

	useEffect(() => {
		dispatch(getLanguage(language));
	}, [dispatch, language]);

	return (
		<>
			<GlobalStyle />

			{children}
		</>
	);
}
